import { cssVar } from '../theme/variables.js';
import * as LabelPrimitive from '@radix-ui/react-label';
import { styled } from 'styled-components';

const Label = styled(LabelPrimitive.Root).withConfig({
  displayName: "Label",
  componentId: "sc-60839ede-0"
})([
  `font-size:14px;font-weight:500;color:`,
  `;user-select:none;cursor:default;`
], cssVar["color-text-secondary"]);

export { Label };
//# sourceMappingURL=Label.js.map
